import { API } from '../../../api';
import { axiosInstance } from '../../../utils/fetcher';

export const getOverChargeItemsFromExcelEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.OVERCHARGE_CLAIM}/GetClaimItemsFromExcel`,
  });
};
